import React, { useContext } from "react";
import { stateContext } from "./Context";
import { MenuItem } from "./MenuItem";

export const Dropdown = ({
  submenus,
  dropdown,
  depthLevel,
  toLowerCase,
  toUpperCase,
  toTitleCase,

}) => {

  let { } = useContext(stateContext)
  
  depthLevel = depthLevel + 1;
  const dropdownClass = depthLevel > 1 ? "dropdown-submenu" : "";

  return (
    <ul className={`dropdown ${dropdownClass} ${dropdown ? "show" : ""}`}>
      {submenus.map((submenu, index) => (
        <MenuItem
          items={submenu}
          key={index}
          depthLevel={depthLevel}
          toLowerCase={toLowerCase}
          toUpperCase={toUpperCase}
          toTitleCase={toTitleCase}
        />
      ))}
    </ul>
  );
};
